const FEMALE_KEY_PARTS = [
  'mother',
  'daughter',
  'sister',
  'aunt',
  'niece',
  'wife',
  'girlfriend',
  'grandmother',
  'granddaughter',
];

const MALE_KEY_PARTS = [
  'father',
  'son',
  'brother',
  'uncle',
  'nephew',
  'husband',
  'boyfriend',
  'grandfather',
  'grandson',
];

const normalizeGender = (gender) => {
  if (!gender) return 'other';
  const value = String(gender).toLowerCase();
  if (value === 'mann' || value === 'male') return 'male';
  if (value === 'kvinne' || value === 'female') return 'female';
  return 'other';
};

const matchesKeyParts = (key, parts) =>
  parts.some((part) => key.includes(part));

const isGenderedKey = (key) => {
  if (!key) return false;
  const normalized = String(key).toLowerCase();
  return matchesKeyParts(normalized, FEMALE_KEY_PARTS) || matchesKeyParts(normalized, MALE_KEY_PARTS);
};

const isFemaleKey = (key) => {
  if (!key) return false;
  return matchesKeyParts(String(key).toLowerCase(), FEMALE_KEY_PARTS);
};

const isMaleKey = (key) => {
  if (!key) return false;
  return matchesKeyParts(String(key).toLowerCase(), MALE_KEY_PARTS);
};

export const filterRelationsByGender = (relations, gender) => {
  const normalizedGender = normalizeGender(gender);
  if (!Array.isArray(relations) || normalizedGender === 'other') return relations || [];

  return relations.filter((relation) => {
    const key = relation?.key;
    if (!key || !isGenderedKey(key)) return true;
    if (normalizedGender === 'female') return isFemaleKey(key);
    if (normalizedGender === 'male') return isMaleKey(key);
    return true;
  });
};
